import { Component, Inject, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AttestorLog } from '../../interfaces/attestor-logs/attestor-log';
import { AttestorLogRepositoryService } from '../../services/attestor-logs/attestor-logs-repository.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-attestor-history-dialog',
    templateUrl: './attestor-history-dialog.component.html',
    styleUrls: ['./attestor-history-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AttestorHistoryDialogComponent {
  private readonly transloco = inject(TranslocoService);

    displayedColumns: string[] = [
        'added',
        'message'
    ];

    protected attestorLogs: AttestorLog[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public orderId: string,
        private attestorLogService: AttestorLogRepositoryService
    ) {
    }

    ngOnInit(): void {
        this.attestorLogService.getAttestorOrderLogs(this.orderId).subscribe(logs => {
            if (logs && logs.length > 0) {
                this.attestorLogs = logs.sort((a, b) => new Date(a.added).getTime() - new Date(b.added).getTime()).filter(log => log.customerVisible);
            } else {
                this.attestorLogs = [{ orderId: this.orderId, id: '', message: this.transloco.translate('attestorHistoryDialog.noAttestorActions'), added: new Date(), customerVisible: true } as AttestorLog];
            }
        });


    }
}